import { create } from 'zustand';
import type { CreateCampaignInput, CreateDealInput } from '@/features/communications';

interface DraftCampaign extends Partial<CreateCampaignInput> {
  dirty?: boolean;
}

interface DraftDeal extends Partial<CreateDealInput> {
  dirty?: boolean;
}

interface CommunicationState {
  // Draft campaign form persistence (survives tab switches)
  draftCampaign: DraftCampaign;
  setDraftCampaign: (draft: DraftCampaign) => void;
  clearDraftCampaign: () => void;

  // Draft deal form persistence
  draftDeal: DraftDeal;
  setDraftDeal: (draft: DraftDeal) => void;
  clearDraftDeal: () => void;

  // Selected campaign for detail drawer
  selectedCampaignId: string | null;
  setSelectedCampaignId: (id: string | null) => void;
}

export const useCommunicationStore = create<CommunicationState>((set) => ({
  draftCampaign: {},
  setDraftCampaign: (draft) => set({ draftCampaign: { ...draft, dirty: true } }),
  clearDraftCampaign: () => set({ draftCampaign: {} }),

  draftDeal: {},
  setDraftDeal: (draft) => set({ draftDeal: { ...draft, dirty: true } }),
  clearDraftDeal: () => set({ draftDeal: {} }),

  selectedCampaignId: null,
  setSelectedCampaignId: (id) => set({ selectedCampaignId: id }),
}));
